<template>
    <v-select v-model="selectedLang"
              class="header-select"
              :options=langList
              :on-change="onChange"
              :searchable="false"></v-select>
</template>

<script>
  import {AVAILABLE_LANGUAGES} from '../constants';
  import locale from '../locale';
  import map from 'lodash/map';

  export default {
    data() {
      return {
        //selectedLang: '',
      };
    },
    computed:{
      langList() {
        
        let langLists = map(AVAILABLE_LANGUAGES, function(item){
          return item.toString() === 'uk' ? 'ua' : item;
        });
        
        return langLists;
      },
      selectedLang() {

        let selected = locale.toString() === 'uk' ? 'ua' : locale.toString();

        return selected;
      },
    },
    methods: {
      onChange(language) {
        let setLang = language;

        if(language.toString() === 'ua'){
          setLang = 'uk'
        }
        
        if (setLang !== locale.toString()) {

          location.href = location.href.replace(`/${locale}/`, `/${setLang}/`);
        }
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/lang/components/Selector.vue